import { render, staticRenderFns } from "./TradeRejected.vue?vue&type=template&id=0f20528a&scoped=true&"
import script from "./TradeRejected.vue?vue&type=script&lang=ts&"
export * from "./TradeRejected.vue?vue&type=script&lang=ts&"
import style0 from "./TradeRejected.vue?vue&type=style&index=0&id=0f20528a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f20528a",
  null
  
)

export default component.exports